import {
  CRM_EVENT,
  CRM_EVENT_SUCCESS,
  CRM_EVENT_ERROR,
  CRM_SAVE_EXIT_EVENT,
  CRM_SAVE_EXIT_EVENT_SUCCESS,
  CRM_SAVE_EXIT_EVENT_ERROR,
} from './crmEventActionConstants';

export const postCrmEvent = (payload) => ({
  type: CRM_EVENT,
  payload,
});

export const postCrmEventSuccess = (payload) => ({
  type: CRM_EVENT_SUCCESS,
  payload,
});

export const postCrmEventError = (payload) => ({
  type: CRM_EVENT_ERROR,
  payload,
});

export const postSaveNExitCrmEvent = (payload) => ({
  type: CRM_SAVE_EXIT_EVENT,
  payload,
});

export const postSaveNExitSuccess = (payload) => ({
  type: CRM_SAVE_EXIT_EVENT_SUCCESS,
  payload,
});

export const postSaveNExitError = (payload) => ({
  type: CRM_SAVE_EXIT_EVENT_ERROR,
  payload,
});
